import { Routes } from '@angular/router';
import { provideStates } from '@ngxs/store';
import { EMEA_BROWSER_LOCALES, provideBrowserLocaleId } from '@shs-digi-care-monorepo/frontend-lib';
import { AutoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { ClwAnalyticsState } from '../clw/store/analytics/analytics.state';
import { ClwRequestsState } from '../clw/store/request/request.state';
import { ClwTasksState } from '../clw/store/task/task.state';
import { NamAnalyticsState } from '../nam/store/analytics/analytics.state';
import { NamRequestsState } from '../nam/store/request/request.state';
import { NamTasksState } from '../nam/store/task/task.state';
import { canActivateAdmin } from './auth/guards/admin.guard';
import { canActivateUser } from './auth/guards/auth.guard';
import { canActivateTaskOwnerOrAdmin } from './auth/guards/task-owner-or-admin.guard';
import { EmeaRedirectGuard } from './emea-redirect/emea-redirect.guard';
import { FeatureGuard } from './shared/guards/feature.guard';
import { MDLA_SCOPE, MDLA_SCOPE_ENUM } from './shared/tokens/mdla-scope.token';

export const NAM_MENU_ROUTE = '/menu';

export const COMMON_ROUTES: Routes = [
    {
        path: '',
        redirectTo: 'menu',
        pathMatch: 'full'
    },
    {
        path: 'menu',
        loadChildren: () => import('../nam/menu/nam-menu.routes').then((m) => m.NAM_MENU_ROUTES),
        providers: [provideBrowserLocaleId('en-US')],
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser]
    },
    {
        path: 'admin',
        loadChildren: () => import('./admin/admin.routes').then((m) => m.ADMIN_ROUTES),
        providers: [provideBrowserLocaleId('en-US')],
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser, canActivateAdmin]
    },
    {
        path: 'escalation',
        loadChildren: () => import('./escalation/escalation.routes').then((m) => m.ESCALATION_ROUTES),
        canActivate: [AutoLoginPartialRoutesGuard, canActivateTaskOwnerOrAdmin]
    },
    {
        path: 'settings',
        loadChildren: () => import('./settings/settings.routes').then((m) => m.SETTINGS_ROUTES),
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser]
    },
    {
        path: 'auth',
        loadChildren: () => import('./auth/auth.routes').then((m) => m.AUTH_ROUTES)
    },
    {
        path: 'clw',
        providers: [
            provideStates([ClwRequestsState, ClwTasksState, ClwAnalyticsState]),
            { provide: MDLA_SCOPE, useValue: MDLA_SCOPE_ENUM.CLW },
            provideBrowserLocaleId('en-GB', { supportedLocales: EMEA_BROWSER_LOCALES })
        ],
        loadChildren: () => import('../clw/app.routes').then((m) => m.CONTRACT_LIFECYCLE_ROUTES),
        data: { feature: 'contractLifecycleWorkflows' },
        canActivate: [AutoLoginPartialRoutesGuard, FeatureGuard]
    },
    {
        path: 'emea',
        children: [{ path: '**', canActivate: [EmeaRedirectGuard], children: [] }]
        // Uncomment for old EMEA
        /*providers: [
            provideStates([EmeaRequestsState, EmeaTasksState, EmeaAnalyticsState]),
            { provide: MDLA_SCOPE, useValue: MDLA_SCOPE_ENUM.EMEA },
            provideBrowserLocaleId('en-GB', { supportedLocales: EMEA_BROWSER_LOCALES })
        ],
        loadChildren: () => import('../emea/app.routes').then((m) => m.EMEA_ROUTES)*/
    },
    //{
    //    path: 'nam',
    //    loadChildren: () => import('./../nam/app.routes').then((m) => m.NAM_ROUTES)
    //},
    // Will be moved to nam/request in the future
    {
        path: 'request',
        providers: [
            provideStates([NamRequestsState, NamTasksState]),
            { provide: MDLA_SCOPE, useValue: MDLA_SCOPE_ENUM.NAM },
            provideBrowserLocaleId('en-US')
        ],
        loadChildren: () => import('./request/request.routes').then((m) => m.REQUEST_ROUTES),
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser]
    },
    {
        path: 'requests',
        providers: [
            provideStates([NamRequestsState, NamAnalyticsState, NamTasksState]),
            { provide: MDLA_SCOPE, useValue: MDLA_SCOPE_ENUM.NAM },
            provideBrowserLocaleId('en-US')
        ],
        loadChildren: () => import('../nam/requests/requests.routes').then((m) => m.REQUESTS_ROUTES),
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser]
    },
    {
        path: 'tasks',
        providers: [
            provideStates([NamTasksState, NamRequestsState, NamAnalyticsState]),
            { provide: MDLA_SCOPE, useValue: MDLA_SCOPE_ENUM.NAM },
            provideBrowserLocaleId('en-US')
        ],
        loadChildren: () => import('../nam/tasks/tasks.routes').then((m) => m.TASKS_ROUTES),
        canActivate: [AutoLoginPartialRoutesGuard, canActivateUser]
    },
    {
        path: '**',
        redirectTo: 'menu'
    }
];
